import { render, staticRenderFns } from "./LeftSidebar.vue?vue&type=template&id=486e9b4b&scoped=true"
import script from "./LeftSidebar.vue?vue&type=script&lang=js"
export * from "./LeftSidebar.vue?vue&type=script&lang=js"
import style0 from "./LeftSidebar.vue?vue&type=style&index=0&id=486e9b4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e9b4b",
  null
  
)

export default component.exports